<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         :closeOnBackdrop="false"
         size="lg"
         :show.sync="show"
      >
         <CRow>
            <CCol>
               <div>
                  <CRow>
                     <CCol>
                        {{ "Fullname: " + firstname + " " + lastname }}
                     </CCol>
                  </CRow>
               </div>
               <hr />

               <label> Curriculum </label>
               <CRow>
                  <CCol>
                     <CInput :value="getClassName(form.batch_id)" disabled />
                  </CCol>
               </CRow>
               <label> Class template </label>
               <CRow>
                  <CCol>
                     <CInput
                        :value="getTemplateName(form.template_id)"
                        disabled
                     />
                  </CCol>
               </CRow>
               <label> Schedule </label>
               <CRow>
                  <CCol>
                     <CInput :value="getSchedule(form.schedule_id)" disabled />
                  </CCol>
               </CRow>
            </CCol>
         </CRow>

         <hr />
         <CRow>
            <CCol> </CCol>
         </CRow>

         <template #footer>
            <CButton
               style="width:200px"
               color="success"
               block
               v-on:click.prevent="attend()"
               type="submit"
               >Submit</CButton
            >
         </template>
         <!-- <pre>{{ $data | json }}</pre> -->
      </CModal>
   </form>
</template>

<script>
import EventBus from "@/eventBus";
import classparticipant from "@/services/class_schedule";
import classbatch from "@/services/batch";

import classtemplate from "@/services/class_template";
import classschedule from "@/services/class_schedule";

export default {
   name: "peoplemodal",

   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         batch_id: [],
         batch_name: [],

         template_id: [],
         template_name: [],
         schedule_id: [],
         schedule_date: [],
         form: {
            people_id: "",
            batch_id: "",
            template_id: "",
            schedule_id: "",
         },
         firstname: "",
         lastname: "",
      };
   },
   computed: {},
   mounted() {},
   created() {
      var self = this;
      EventBus.$on("OPEN_SHOW_ATTEND", (params) => {
         if (params.data) {
            classparticipant
               .getParticipantbyID(params.data)

               .then((res) => {
                  console.log(params, "params");
                  console.log(res, "data");
                  this.datas = res;
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.people_id = params.data;
                  self.firstname = res.people[0].firstname;
                  self.lastname = res.people[0].lastname;
                  self.form.batch_id = params.batch_id;
                  self.form.template_id = params.template_id;
                  self.form.schedule_id = params.schedule_id;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.people_id = "";
            self.form.batch_id = "";
            self.form.template_id = "";
            self.form.schedule_id = "";
         }
         classbatch.getBatch().then((res) => {
            //this.classname = res.data
            for (let i = 0; i <= res.data.length - 1; i++) {
               this.batch_id.push(res.data[i].id);
               this.batch_name.push(res.data[i].name);
            }
         });
         classbatch.getBatch().then((res) => {
            //this.classname = res.data
            for (let i = 0; i <= res.data.length - 1; i++) {
               this.batch_id.push(res.data[i].id);
               this.batch_name.push(res.data[i].name);
            }
         });
         classtemplate.getTemplate().then((res) => {
            //this.classname = res.data
            for (let i = 0; i <= res.data.length - 1; i++) {
               this.template_id.push(res.data[i].id);
               this.template_name.push(res.data[i].name);
            }
            classschedule.getSchedule().then((res) => {
               //this.classname = res.data
               console.log(res, "schedule");
               for (let i = 0; i <= res.data.length - 1; i++) {
                  this.schedule_id.push(res.data[i].id);
                  this.schedule_date.push(res.data[i].class_date);
               }
            });
         });
      });
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      attend() {
         this.show = false;
         classparticipant
            .setAttend(this.form)
            .then((res) => {
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },
      getClassName(temp) {
         return this.batch_name[this.batch_id.indexOf(temp)];
      },
      getTemplateName(temp) {
         return this.template_name[this.template_id.indexOf(temp)];
      },
      getSchedule(temp) {
         return this.schedule_date[this.schedule_id.indexOf(temp)];
      },
   },
};
</script>
